import * as $ from 'jquery';
import { forEach } from 'lodash-es';
import qs from 'qs';
import Vue from 'vue';
import { Component, Provide, Watch } from 'vue-property-decorator';
import DefaultModal from '../../components/modal';
import UnisProductModal from '../../components/unisProductModal';
import clientService from '../../services/axios/axiosService';
import tmsService from '../../services/axios/tmsService';
import tmsServiceToJson from '../../services/axios/tmsServiceToJson';
import { analytics } from '../../services/analytics';
import template from './login.vue';
@Component({
    mixins: [template],
    components: {
        DefaultModal,
        UnisProductModal,
    },
})
export default class Login extends Vue {
    // Data
    resetPassword: string = 'resetPassword';
    resetPasswordTitle: string = 'Reset Password';
    resetPasswordMessage: string = 'Enter your new password below:';
    resetPasswordStyle: any = {
        display: 'none',
    };
    rightBtnStyle: any = {
        'background-color': '#15223d !important',
    };
    passwordHeight: number = 325;
    newPassword: string = '';
    retypePassword: string = '';
    token: string = '';
    email: string = '';
    searchByReference: string = '';
    validatePassword: boolean = false;
    isshowPassword: boolean = true;
    isshowLogin: boolean = true;
    isForgotPassword: boolean = false;
    isResetPassword: boolean = false;
    isLoding: boolean = false;

    @Provide()
    loginData: any = this.$store.getters.loginData;

    @Provide()
    formData: object = this.$store.getters.formData;

    @Watch('formData.showLoding', {
        deep: true,
        immediate: true,
    })
    showLoginData(val: any, oldVal: any, event: any) {
        if (!val) this.isLoding = val;
    }

    @Watch('formData.showLoding', {
        deep: true,
        immediate: true,
    })
    showLoding(val: any, oldVal: any, event: any) {
        if (!val) this.isLoding = val;
    }

    trackShipment() {
        function getSearchText(searchText: string) {
            const splitter = ',';
            const keyWords = new Set<string>([]);

            forEach(searchText.split(splitter), i => {
                keyWords.add(i.trim());
            });

            return Array.from(keyWords.values()).join(splitter);
        }

        this.$router.push({
            name: 'TrackShipmentGuest',
            query: {
                searchText: getSearchText(this.searchByReference || ''),
            },
        });
    }

    showOrder(index: number) {
        let orderData = this.formData['orders'][index];
        this.formData['originChose'] = orderData.originChose;
        this.formData['originDate'] = orderData.originDate;
        this.formData['originLocation'] = orderData.originLocation;
        this.formData['destinationDate'] = orderData.destinationDate;
        this.formData['destinationLocation'] = orderData.destinationLocation;
        this.formData['transitChose'] = orderData.transitChose;
        this.formData['destinationChose'] = orderData.destinationChose;
        this.formData['hasTrackTableRows'] = orderData.hasTrackTableRows;
        this.formData['trackFail'] = orderData.trackFail;
        this.formData['trackResultMsg'] = orderData.trackResultMsg;
        this.formData['trackTable'] = orderData.trackTable;
        this.formData['hasTrackTableRows'] = true;
        $('.selected-row').removeClass('selected-row');
        $('#orderRow' + index).addClass('selected-row');
    }

    async signIn() {
        let result = await this.$validator.validateAll();
        analytics.trackFormSubmit({
            formName: 'login',
            status: result ? 'attempted' : 'failure',
        });
        if (result) {
            this.isLoding = true;
            this.$store.dispatch('signIn', this.formData);
        }
    }

    @Watch('formData.hasTrackTableRows', {
        deep: true,
        immediate: true,
    })
    scrollDown(val: any, oldVal: any, event: any) {
        if (val) {
            $('html,body').animate(
                {
                    scrollTop: '800px',
                },
                200
            );
        }
    }

    @Watch('formData.showMultiOrder', {
        deep: true,
        immediate: true,
    })
    scrollDown2(val: any, oldVal: any, event: any) {
        if (val) {
            $('html,body').animate(
                {
                    scrollTop: '400px',
                },
                200
            );
        }
    }

    inputChangeEvent() {
        this.$store.dispatch('clearLoginFailMsg');
    }

    clearTrackErrorMsg() {
        this.$store.dispatch('clearTrackErrorMsg');
    }

    remeberMe() {
        this.$store.dispatch('changeRemeberMe', this.formData);
    }

    created() {
        this.$store.dispatch('validatedAndLogin');
    }

    mounted() {
        if (
            typeof this.$route.query.token == 'string' &&
            typeof this.$route.query.email == 'string'
        ) {
            this.token = this.$route.query.token.toString();
            this.email = this.$route.query.email.toString();
            this.showPasswordModal();
        }
    }

    // watch
    @Watch('formData.sendForgotEmailstaus', {
        deep: true,
        immediate: true,
    })
    onForgotPasswordSend(val: any, oldVal: any, event: any) {
        if (val >= 1) {
            this.$modal.hide(this.modalName);
        }
    }

    // Modal
    @Provide()
    modalName: string = 'forgotPassWord';

    @Provide()
    modalMessage: string = `Tell us your email address and we'll email you a link to re-set your password.`;

    @Provide()
    modalTitle: string = 'Forgot Password';

    @Provide()
    modalConfirmText: string = 'reset password';

    @Provide()
    modalCancelText: string = 'Nevermind';

    @Provide()
    maxWidth: number = 700;

    @Provide()
    width: number = 600;

    @Provide()
    maxHeight: number = 340;
    @Provide()
    height: number = 340;
    showModal() {
        this.isshowLogin = false;
        this.isForgotPassword = true;
    }

    closeModal() {
        this.isshowLogin = true;
        this.isForgotPassword = false;
        this.isResetPassword = false;
    }

    inputForgotPassword() {
        this.$store.dispatch('validateForgotMsg', this.formData);
    }

    confirmModal() {
        this.$store.dispatch('forgotPassword', this.formData);
    }

    showPasswordModal() {
        this.isResetPassword = true;
        this.isshowLogin = false;
    }

    async confirmReset() {
        let newPaswordResult = await this.$validator.validate('newPassword', this.newPassword);
        let retypePaswordResult = await this.$validator.validate(
            'retypePassword',
            this.retypePassword
        );
        if (newPaswordResult && retypePaswordResult && !this.validatePassword) {
            let url = 'write/write_reset_password.php';
            let json3 = {
                email: this.email,
                token: this.token,
                new_password: this.newPassword,
                response_type: 1,
            };
            clientService
                .post(url, qs.stringify(json3))
                .then(res => {
                    const data = res.data;
                    if (data.status === true) {
                        this.email = '';
                        this.token = '';

                        const messageModel = {};
                        messageModel['isShowMessageModel'] = true;
                        messageModel['messageModelTitle'] = 'Success';
                        messageModel['messageModelMessage'] = 'Password successfully changed!';
                        messageModel['titleColor'] = 'green';
                        this.$store.dispatch('updateMessageModel', messageModel);
                        this.$modal.hide(this.resetPassword);
                        this.$router.push('Login');
                    } else {
                        const messageModel = {};
                        messageModel['isShowMessageModel'] = true;
                        messageModel['messageModelTitle'] = 'Failed';
                        messageModel['messageModelMessage'] = data.error;
                        messageModel['titleColor'] = 'red';
                        this.$store.dispatch('updateMessageModel', messageModel);
                    }
                })
                .catch(error => {
                    this.isLoding = false;
                    console.log(error);
                });
        } else {
            this.isLoding = false;
            console.log(false);
        }
    }

    // Modal

    checkPassword() {
        if (this.newPassword != this.retypePassword && this.retypePassword != '') {
            this.validatePassword = true;
        } else {
            this.validatePassword = false;
        }
    }

    isPasswordComplete() {
        return this.newPassword && this.retypePassword;
    }

    openFile(url: string) {
        window.open(url);
    }

    showPassword() {
        this.isshowPassword = !this.isshowPassword;
    }

    isSignUpLoding: boolean = false;
    isProductModal: boolean = false;
    isSignUp: boolean = false;
    isVerifyEmail: boolean = false;
    isOnResendEmail: boolean = false;

    signUp: any = {
        isAccountCode: true,
        code: ' ',
        email: ' ',
        company_id: 23,
    };
    signUpEmailErr: any = false;
    accountCodeErr: any = false;

    onWhatAccountCode() {
        this.isProductModal = true;
    }

    closeReset() {
        this.isProductModal = false;
    }

    onSignUp() {
        this.isSignUp = true;
        this.isshowLogin = false;
        this.isForgotPassword = false;
        this.isResetPassword = false;
    }

    onSignIn() {
        this.isSignUp = false;
        this.isshowLogin = true;
        this.isForgotPassword = false;
        this.isResetPassword = false;
    }

    verifyEmail() {
        this.$router.push({
            name: 'VerifyEmail',
            query: {},
        });
    }

    onSubmitSignUp(scope: any) {
        this.$validator.validateAll(scope).then(res => {
            if (res) {
                this.userEmail(this.isSignUpLoding);
            }
        });
    }
    getCompanyId() {
        let name,
            value,
            str = location.href,
            num = str.indexOf('?');
        str = str.substr(num + 1);
        let arr = str.split('?');
        let parameter = {};
        for (let i = 0; i < arr.length; i++) {
            num = arr[i].indexOf('=');
            if (num > 0) {
                name = arr[i].substring(0, num);
                value = arr[i].substr(num + 1);
                parameter[name] = value;
            }
        }
        if (parameter['company_id']) this.signUp.company_id = parameter['company_id'];
    }
    getRegisterLoging(name: string) {
        const host = window.location.hostname;
        if (
            host === 'localhost' ||
            host === 'shipdev.unisco.com' ||
            host === 'shipstage.unisco.com'
        ) {
            this.locationHrefSpId(0, 'https://stagesso.unisco.com/samlsso?spEntityID=', name);
        } else if (host === 'ship.unisco.com') {
            this.locationHrefSpId(0, 'https://sso.unisco.com/samlsso?spEntityID=', name);
        } else if (host === 'demo.unisco.com') {
            this.locationHrefSpId(1, 'https://sso.unisco.com/samlsso?spEntityID=', name);
        }
    }

    private locationHrefSpId(demo: any, url: any, name: any) {
        tmsService.get(`/apinew/cp/spId?demo=${demo}`).then(
            (response: any) => {
                if (name == 'google') {
                    if (response.data.data)
                        window.location.href = `${url}${response.data.data.google_sp_entity_id}`;
                }
                if (name == 'facebook') {
                    if (response.data.data)
                        window.location.href = `${url}${response.data.data.facebook_sp_entity_id}`;
                }
            },
            (err: any) => {
                if (err.response.data && err.response.data.message) {
                    if (err.response.data.message.company_id) {
                        this.err(err.response.data.message.company_id[0]);
                        return;
                    }
                    this.err(err.response.data.message);
                }
            }
        );
    }
    onResendEmail() {
        this.getCompanyId();
        tmsServiceToJson.post('/apinew/cp/user/email', this.signUp).then(
            (response: any) => {
                if (response.data.status == 1) {
                    this.succeed('Resend email succeed !');
                }
            },
            (err: any) => {
                if (err.response.data && err.response.data.message) {
                    if (err.response.data.message.company_id) {
                        this.err(err.response.data.message.company_id[0]);
                        return;
                    }
                    this.err(err.response.data.message);
                }
            }
        );
    }

    userEmail(isLoding: boolean) {
        this.isSignUpLoding = true;
        this.getCompanyId();
        tmsServiceToJson.post('/apinew/cp/user/signup', this.signUp).then(
            (response: any) => {
                isLoding = false;
                if (response.data.status == 1) {
                    this.isVerifyEmail = true;
                    this.isSignUp = false;
                    this.isshowLogin = false;
                    this.isForgotPassword = false;
                    this.isResetPassword = false;
                    isLoding = false;
                }
            },
            (err: any) => {
                this.isSignUpLoding = false;
                this.signUpEmailErr = false;
                this.accountCodeErr = false;
                if (err.response.data && err.response.data.message) {
                    if (err.response.data.message.company_id) {
                        this.err(err.response.data.message.company_id[0]);
                        return;
                    }
                    if (err.response.data.message.indexOf('email') > -1) {
                        this.signUpEmailErr = err.response.data.message;
                    } else {
                        this.err(err.response.data.message);
                    }
                }
            }
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/login/index.ts